import React from 'react'
import { Link } from 'react-router-dom'
import './Dropdown.css'

const Dropdown = (props) => {
  return (
    <>
      <ul className='dropdown-menu'>
        {props.menuitems.map((item, index) => {
          return (
            <li key={index}>
              <Link className={item.cName} to={item.path}>
                {item.title}
              </Link>
            </li>
          )
        })}
      </ul>
    </>
  )
}

export default Dropdown
